import './compiled/sass/App.css';

import * as React from 'react';

import * as localforage from 'localforage';
import moment from 'moment';
import * as PropTypes from 'prop-types';
import Async from 'react-code-splitting';
import { RouteComponentProps } from 'react-router';
import { Route } from 'react-router-dom';

import {
  generateQueryString,
  parseQueryString,
} from './helpers/queryStringUtils';
import { identifyUser } from './helpers/segment';
import Conversation from './sections/Conversation';
import ConversationsList from './sections/ConversationsList';
import socket from './services/SocketService';
import {
  ConversationUrlParams,
  TranslationFunction,
  UserLanguages,
  UserSession,
} from './types';

const ActivityFormContainer = props => <Async load={import('./components/ActivityFormContainer')} componentProps={props} />;

export interface AppProps extends RouteComponentProps<ConversationUrlParams> {
    translate?: TranslationFunction;
}

interface AppState {
    conversationId?: number,
    onDesktop?: boolean
}
interface AppContext {
    session: UserSession
}
interface AppChildContext {
    socket: WebSocket,
    onDesktop: boolean
}

function checkConversationIdQueryStringFallback({ location, history }: AppProps) {
    // backward compatibility for querystring conversation_id
    const queryObj = parseQueryString(location.search);

    if (queryObj.conversation_id) {
        // extract conversation_id from query string
        const { conversation_id, ...extraQueryObj } = queryObj;
        const extraQuery = generateQueryString(extraQueryObj);

        history.push({
            pathname: `/conversation/${queryObj.conversation_id}`,
            search: `${extraQuery ? `?${extraQuery}` : ''}`
        });
    }
}

class App extends React.Component<AppProps, AppState> {
    static contextTypes = {
        session: PropTypes.object.isRequired
    };

    static childContextTypes = {
        socket: PropTypes.object.isRequired,
        onDesktop: PropTypes.bool
    };

    context: AppContext;

    constructor(props) {
        super(props);

        this.state = this.updateWindowDimensions({
            onDesktop: false
        });

        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }
    componentDidMount() {
        window.addEventListener('resize', () => this.updateWindowDimensions());
        socket.on('id.required', () => socket.send('identify', { api_key: this.context.session.sid }));
        socket.connect();
        moment.locale(this.context.session && this.context.session.user_language || UserLanguages.ENGLISH);
        identifyUser(this.context.session);
        checkConversationIdQueryStringFallback(this.props);
        window.addEventListener('beforeunload', async () => {
            if (process.env.REACT_APP_ENV !== 'local') {
                await localforage.clear();
            }
        });
    }
    componentWillUnmount() {
        window.removeEventListener('resize', () => this.updateWindowDimensions());
    }

    getChildContext(): AppChildContext {
        return {
            socket,
            onDesktop: this.state.onDesktop
        };
    }
    /**
     * Detect mobile/desktop for conditionally rendering components
     */
    updateWindowDimensions(state?: AppState) {
        let onDesktop = false;

        if (window.matchMedia('(min-width: 1024px)').matches) {
            onDesktop = true;
        }

        if (this.state && this.state.onDesktop === onDesktop) {
            return;
        }

        if (state) {
            return {
                ...state,
                onDesktop
            };
        }

        this.setState({
            onDesktop
        });
    }
    render() {
        const { url } = this.props.match;
        const { onDesktop } = this.state;
        const conversationRoute = `${url}conversation/:conversationId`;
        const activityFormRoute = `${url}log/:conversationId`;

        const appContainer = (
            <div className={`sfmessenger flexbox__row`}>
                {/* Only render a single route on mobile */}
                <Route path={url} component={ConversationsList} exact={!onDesktop} />
                <Route path={conversationRoute} component={Conversation} exact={!onDesktop} />
                <Route path={activityFormRoute} component={ActivityFormContainer} exact={!onDesktop} />
            </div>
        );

        return appContainer;
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx